module.exports = __webpack_public_path__ + "img/stock-m-process.f7e00ab7.png";